import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { SampleActions, SAMPLE_STATE_NAMESPACE } from './sample.module-types';

export const dispatchSampleAction: DispatchAction<SampleActions> = getDispatch(
  SAMPLE_STATE_NAMESPACE
);
